import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

// Take-header badge: how many of the take's interactions (including quiz
// feedback ones) are disabled and thus excluded from testing. Renders
// nothing when the count is zero so untouched takes stay clean.
export default function DisabledInteractionsBadge(props: { count: number }) {
  const { t } = useTranslation();
  if (props.count === 0) return null;

  const label = t("disabled_interactions_tooltip", {
    count: props.count,
  }) as string;

  return (
    <Tooltip title={label} placement="top" arrow>
      <span
        className="my-auto flex flex-shrink-0 items-center gap-0.5 text-[14px] text-creator-text-sub"
        aria-label={label}
        data-testid="take-disabled-badge"
      >
        <VisibilityOffOutlinedIcon fontSize="inherit" />
        <span
          className="text-[11px] font-semibold"
          data-testid="take-disabled-badge-count"
        >
          {props.count}
        </span>
      </span>
    </Tooltip>
  );
}
